import type { IconNames } from '@repo/foundations';

export const ANALYTICS_EVENTS = {
	AI_SUGGESTION_VIEW: 'ai/suggestion/view',
	AI_SUGGESTION_APPROVE: 'ai/suggestion/approve',
	AI_SUGGESTION_APPROVE_FAILED: 'ai/suggestion/approve/failed',
	AI_SUGGESTION_APPROVE_SUCCESS: 'ai/suggestion/approve/success',
	AI_SUGGESTION_REJECT: 'ai/suggestion/reject',
} as const;

export const TOOLS_ICONS: Record<string, IconNames> = {
	run_sql: 'code',
	execute_sql: 'code',
	catalog_integrations: 'search',
	search_and_summary: 'search',
	suggest_monitors_agent: 'activity',
	search_data_assets: 'search',
	search_documentation: 'search',
	search_semantic_views: 'database',
	take_note: 'note',
	chart: 'chartBar',
	web_search: 'world',
	read_web_page: 'world',
	create_todos: 'list',
	submit_relevant_table_columns: 'database',
	document_findings: 'fileText',
	trigger_agent: 'brain',
	createMetrics: 'chartBar',
	createDashboard: 'chartBar',
	submit_findings: 'check',
} as const;

export const TOOLS_GROUP_LABELS: Record<string, string> = {
	suggest_monitors_agent: 'Suggesting monitors',
	bi_analyst_agent: 'BI Analyst Agent',
	search: 'Search',
	semantic_search: 'Semantic Search',
	take_note: 'Taking note',
} as const;
